import React, { useContext, useEffect } from "react";

import { Grid, Grow } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import { Margin } from "../styles/Emissao";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import useCalculosTributacao from "../controllers/RulesEmissaoCalculosTributacao";
import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoIPIDevolvido = ({ ...props }) => {
  const {
    productIpiReturnedAliquot,
    setProductIpiReturnedAliquot,
    productIpiReturnedValue,
    setProductIpiReturnedValue,
  } = useContext(ParametrosProdutoContext);

  const { visualizationOnly, nfeMontageSubtype } = useContext(EmissaoContext);

  const { handleCalcIpiReturned } = useCalculosTributacao();

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcIpiReturned();
  }, [handleCalcIpiReturned, nfeMontageSubtype]);

  return (
    <Grid container spacing={2}>
      <Grow in={true}>
        <Grid item sm={12}>
          <Card line="left">
            <Margin top="10">
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <TextField
                    value={productIpiReturnedAliquot}
                    setValue={setProductIpiReturnedAliquot}
                    size="small"
                    label="Alíquota do IPI Devolvído"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={6}>
                  <TextField
                    value={productIpiReturnedValue}
                    setValue={setProductIpiReturnedValue}
                    size="small"
                    label="Valor do IPI Devolvído"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
              </Grid>
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default TabEmissaoIPIDevolvido;
